import { formatMoney } from "@/lib/api";
import { FABRICACION } from "@/lib/statuses";

const FAB_LBL = { ...Object.fromEntries(FABRICACION.map((s) => [s.value, s])), solicitar_base: { label: "Solicitar base", cls: "bg-orange-100 text-orange-900" } };
const DIAS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
const dia = (s) => { const [y, m, d] = String(s).slice(0, 10).split("-").map(Number); return y ? DIAS[new Date(y, m - 1, d).getDay()] : ""; };
const fmtD = (s) => { const [y, m, d] = String(s).slice(0, 10).split("-"); return y ? `${d}/${m}/${y}` : ""; };

// Estado por producto derivado de las unidades de Fabricación (misma regla que el módulo).
export const itemFab = (o, i, it) => {
  const key = `${i}:${it.product_id || ""}`;
  const qty = Number(it.cantidad || 0);
  const g = o.fab_unidades || {};
  const hechas = o.estado_fabricacion === "listo" ? qty : Number((o.fab_parcial || {})[key] || 0);
  const est = Array.from({ length: qty }, (_, k) => g[`${key}#${k + 1}`]?.estado || (k + 1 <= hechas ? "listo" : "pendiente"));
  const listos = est.filter((e) => e === "listo").length;
  let estado = "pendiente";
  if (qty && listos === qty) estado = "listo";
  else if (listos > 0) estado = "parcial";
  else if (est.includes("en_proceso")) estado = "en_proceso";
  else if (est.length) estado = est[0];
  return { estado, falta: qty - listos };
};

export const Falta = ({ items, testid }) => (items.length ? (
  <div className="text-[9px] leading-tight opacity-80 mt-0.5" data-testid={testid}>Falta: {items.join(", ")}</div>
) : null);

export const faltaFab = (o) => (o.items || []).map((it, i) => ({ it, f: itemFab(o, i, it).falta })).filter((x) => x.f > 0).map((x) => `${x.it.product_name} (${x.f})`);
export const faltaTodos = (o) => (o.items || []).map((it) => `${it.product_name} (${it.cantidad})`);
export const faltaEntrega = (o) => {
  if (o.estado_entrega === "entregado") return [];
  const depto = ["departamento", "expreso"].includes(o.envio_tipo);
  const cr = o.col_resumen;
  if (depto && !(o.numero_guia || (o.guias || []).length)) return ["Guía"];
  if (depto && cr?.total > 0 && cr.colocados < cr.total) return [`Traslado y colocación (${cr.colocados}/${cr.total})`];
  return faltaTodos(o);
};

export const ProductosCell = ({ o }) => (
  <ul className="space-y-1" data-testid={`productos-${o.numero}`}>
    {(o.items || []).map((it, i) => {
      const f = itemFab(o, i, it);
      const s = FAB_LBL[f.estado] || FAB_LBL.pendiente;
      const det = [it.tamano && `Tamaño: ${it.tamano}`, it.estilo && `Estilo: ${it.estilo}`, it.tela && `Tela: ${it.tela}`, it.color && `Color: ${it.color}`].filter(Boolean).join(" | ");
      return (
        <li key={i} className="text-[11px] leading-tight">
          <div className="font-bold">{it.cantidad}x {it.product_name}</div>
          {det && <div className="text-[10px] opacity-75">{det}</div>}
          {(it.modificadores || []).length > 0 && <div className="text-[10px] opacity-75">{it.modificadores.map((m) => m.nombre).join(", ")}</div>}
          <div className="text-[10px]">Fab: <span className={`inline-block rounded px-1 font-semibold ${s.cls}`}>{s.label}</span></div>
        </li>
      );
    })}
  </ul>
);

export const FechasCell = ({ o }) => {
  if (!o.fecha_entrega) return <span className="text-zinc-700 text-[11px] font-black" data-testid={`fechas-${o.numero}`}>SIN FECHA</span>;
  const h = o.fecha_entrega_hasta && o.fecha_entrega_hasta !== o.fecha_entrega ? o.fecha_entrega_hasta : null;
  return (
    <div className="text-[11px] leading-tight" data-testid={`fechas-${o.numero}`}>
      <div className="font-semibold text-orange-700 whitespace-nowrap">{fmtD(o.fecha_entrega)}{h && ` – ${fmtD(h)}`}</div>
      <div className="text-[#002FA7] font-semibold">{dia(o.fecha_entrega)}{h && ` - ${dia(h)}`}</div>
    </div>
  );
};

const Fila = ({ l, v, cls = "" }) => (
  <div className={`flex justify-between gap-2 ${cls}`}><span>{l}</span><span className="tabular-nums whitespace-nowrap">{v}</span></div>
);

export const PagoCell = ({ o }) => {
  const total = Number(o.total || 0);
  const envio = Number(o.envio_precio || 0);
  const prod = Number(o.subtotal ?? total - envio);
  const ant = Number(o.anticipo || 0);
  const cobrar = Number(o.a_cobrar ?? o.saldo_pendiente ?? total - ant);
  return (
    <div className="text-[10px] leading-tight min-w-[100px]" data-testid={`pago-${o.numero}`}>
      <Fila l="Productos:" v={formatMoney(prod)} />
      <Fila l="Envío:" v={formatMoney(envio)} />
      <Fila l="Total:" v={formatMoney(total)} cls="font-bold text-[11px]" />
      <Fila l="Anticipo:" v={formatMoney(ant)} />
      <div className="flex justify-between gap-2 items-baseline mt-0.5 font-black">
        <span className="whitespace-nowrap">A cobrar:</span><span className="tabular-nums text-sm whitespace-nowrap" data-testid={`a-cobrar-${o.numero}`}>{formatMoney(cobrar)}</span>
      </div>
    </div>
  );
};
